export default __webpack_public_path__ + "static/media/(96).6fcf478c.jpg";